import { useRef, useEffect } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const TOOLBAR_OPTIONS = [
  ['bold', 'italic', 'underline', 'strike'],
  [{ header: 1 }, { header: 2 }, { header: 3 }],
  ['blockquote'],
  [{ list: 'bullet' }, { list: 'ordered' }],
  ['link', 'image'],
  ['clean'],
];

export default function QuillEditor({ value, onChange }) {
  const containerRef = useRef(null);
  const quillRef = useRef(null);
  const isInternalChange = useRef(false);

  useEffect(() => {
    if (!containerRef.current || quillRef.current) return;

    const quill = new Quill(containerRef.current, {
      theme: 'snow',
      modules: { toolbar: TOOLBAR_OPTIONS },
    });

    quill.on('text-change', () => {
      isInternalChange.current = true;
      const html = quill.root.innerHTML;
      onChange(html === '<p><br></p>' ? '' : html);
    });

    quillRef.current = quill;

    if (value) {
      quill.root.innerHTML = value;
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!quillRef.current) return;
    if (isInternalChange.current) {
      isInternalChange.current = false;
      return;
    }
    const current = quillRef.current.root.innerHTML;
    if (value !== current) {
      quillRef.current.root.innerHTML = value || '';
    }
  }, [value]);

  return <div ref={containerRef} />;
}
